'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var addCookiePrefix = function addCookiePrefix(cookieName) {
  return 'VZT_' + cookieName;
};

var Cookie = (_temp = _class = function Cookie() {
  _classCallCheck(this, Cookie);
}, _class.AUTH_TOKEN = addCookiePrefix('TOKEN'), _class.OLD_AUTH_TOKEN = 'CS', _class.CULTURE = addCookiePrefix('CULTURE'), _class.SIGN_UP_STEP = addCookiePrefix('SU_STEP'), _class.TRANSACTION_KEY = addCookiePrefix('T_KEY'), _class.PAYMENT_METHOD = addCookiePrefix('P_METHOD'), _class.CLINIC_KEY = addCookiePrefix('C_KEY'), _class.ACCOUNT_KEY = addCookiePrefix('A_KEY'), _class.PAYMENT_TYPE_KEY = addCookiePrefix('PT_KEY'), _class.CARE_PRODUCT = addCookiePrefix('CARE'), _class.ENABLE_RAMADAN = addCookiePrefix('ENABLE_RAMADAN'), _class.START_ROUTE = addCookiePrefix('START_ROUTE'), _class.END_ROUTE = addCookiePrefix('END_ROUTE'), _class.PAGE_TITLE = addCookiePrefix('PAGE_TITLE'), _class.RETURN_URL = addCookiePrefix('RETURN_URL'), _class.ENABLE_SKIP_PAYMENT = addCookiePrefix('ENABLE_SKIP_PAYMENT'), _class.EXPIRY_TIME = addCookiePrefix('EXPIRY_TIME'), _class.COOKIES_INIT_TIME = addCookiePrefix('COOKIES_INIT_TIME'), _class.getAllCookies = function () {
  return [Cookie.AUTH_TOKEN, Cookie.OLD_AUTH_TOKEN, Cookie.CULTURE, Cookie.SIGN_UP_STEP, Cookie.TRANSACTION_KEY, Cookie.PAYMENT_METHOD, Cookie.CLINIC_KEY, Cookie.ACCOUNT_KEY, Cookie.PAYMENT_TYPE_KEY, Cookie.CARE_PRODUCT, Cookie.ENABLE_RAMADAN, Cookie.START_ROUTE, Cookie.END_ROUTE, Cookie.PAGE_TITLE, Cookie.RETURN_URL, Cookie.ENABLE_SKIP_PAYMENT, Cookie.EXPIRY_TIME, Cookie.COOKIES_INIT_TIME];
}, _class.set = function (name, value, options) {
  _jsCookie2.default.set(name, value, _extends({
    expires: parseInt(process.env.REACT_APP_DEFAULT_COOKIE_EXPIRY_DATE),
    secure: process.env.REACT_APP_FORCE_HTTPS === 'true',
    domain: process.env.REACT_APP_TOKEN_DOMAIN
  }, options));
}, _class.get = function (name) {
  return _jsCookie2.default.get(name);
}, _class.remove = function (name, options) {
  return _jsCookie2.default.remove(name, _extends({}, options, {
    domain: process.env.REACT_APP_TOKEN_DOMAIN
  }));
}, _temp);
exports.default = Cookie;
module.exports = exports['default'];